import { getSelectorRoot } from 'utils/selectors';

const getCasinoData = getSelectorRoot('casinoData');

export const getCategories = getCasinoData('categories');
export const getCasinoGameTournaments = getCasinoData('casinoGameTournaments');
export const getJackpotData = getCasinoData('JackpotData');
export const getSportsbookJackpotData = getCasinoData('SportsbookJackpotData');
export const getCasinoGameJackpot = getCasinoData('casinoGameJackpot');
export const getCachedTournamentsOptions = getCasinoData(
  'cachedTournaments',
  'options'
);
export const getCachedTournamentsData = getCasinoData(
  'cachedTournaments',
  'tournamentsData'
);
export const getIsLoaded = getCasinoData('isLoaded');
export const getCachedGamesActiveCategories = getCasinoData(
  'cachedGames',
  'activeCategories'
);
export const getSelectedCasinoGame = getCasinoData('selectedCasinoGame');

export const getJoinedTournaments = getCasinoData('joinedTournaments');
export const getSelectedCasinoCategoryId = getCasinoData(
  'selectedCasinoCategoryId'
);
export const getTournamentActiveProductTypeId = getCasinoData(
  'tournamentActiveProductTypeId'
);

export const getOnlinePlayersCrashGamesIds = getCasinoData(
  'onlinePlayersCrashGamesIds'
);

export const getOnlinePlayersCrashGamesData = getCasinoData(
  'onlinePlayersCrashGamesData'
);
